export enum CarePathActivityConditionRestriction {
    mustBeFalse = 'mustBeFalse',
    mustBeTrue = 'mustBeTrue',
}
